import React, { useEffect } from "react";
import SEO from "../components/SEO";
import { PAGE_META } from "../data/pageMeta";

export default function MentionsLegales() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <>
      <SEO {...PAGE_META["/mentions-légales"]} />
      <section className="container-tight py-16 max-w-3xl">
        <span className="chip mb-4">Informations</span>
        <h1 className="font-serif text-4xl md:text-5xl font-medium text-[#1a1815] tracking-tight leading-[1.05]">
          Mentions légales
        </h1>

        <div className="mt-10 space-y-8 text-[#4a4642] leading-relaxed">
          <div>
            <h2 className="font-serif text-2xl font-medium text-[#1a1815] mb-3">Éditeur du site</h2>
            <p>Jean-Christophe HAPPILLON — Coach sportif & praticien en fasciathérapie</p>
            <p>1 Rue Hélène Boucher, 31130 Quint-Fonsegrives</p>
            <p>Cabinet : 5 bis rue du négoce, 31650 Saint-Orens-de-Gameville</p>
            <p>Téléphone : 07 82 47 63 36</p>
            <p>Email : jc.happillon@gmail.com</p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium text-[#1a1815] mb-3">Hébergement</h2>
            <p>Le site est hébergé par Emergent — conformément au RGPD européen.</p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium text-[#1a1815] mb-3">Propriété intellectuelle</h2>
            <p>L'ensemble des contenus (textes, images, logos, articles de blog) est la propriété exclusive de Jean-Christophe Happillon. Toute reproduction, même partielle, est interdite sans autorisation écrite.</p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium text-[#1a1815] mb-3">Données personnelles</h2>
            <p>Les données collectées via le formulaire de contact ne sont utilisées que pour répondre à votre demande. Elles ne sont ni vendues ni transmises à des tiers. Vous disposez d'un droit d'accès, de rectification et de suppression conformément au RGPD.</p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium text-[#1a1815] mb-3">Cookies</h2>
            <p>Le site utilise des cookies techniques pour son bon fonctionnement. Aucun cookie de traqueur publicitaire n'est utilisé.</p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium text-[#1a1815] mb-3">Crédits photos</h2>
            <p>Photographies : Jean-Christophe Happillon et prestataires. Toute utilisation non autorisée est interdite.</p>
          </div>
        </div>
      </section>
    </>
  );
}
